import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import { StoryElement } from "@quintype/components";
import Breadcrumb from "./../shared/breadcrumbs";
import { produce } from "immer";
import { DfpAd } from "../../../../atoms/dfp-ad";
import { isPremium } from "../../../../../../isomorphic/data/story";

import styles from "../text-story-page/styles.m.css";
import stylesVideo from "./styles.m.css";

class VideoStory extends Component {
  render() {
    const renderSocialMedia = get(this.props, ["renderSocialMedia"], () => null);
    const renderSidebar = get(this.props, ["renderSidebar"], () => null);
    const renderHeaderCard = get(this.props, ["renderHeaderCard"], () => null);
    const renderFooter = get(this.props, ["renderFooter"], () => null);
    const renderfloatingBar = get(this.props, ["renderfloatingBar"], () => null);
    const renderStoryNewsletter = get(this.props, ["renderStoryNewsletter"], () => null);
    const getStorycardLength = get(this.props, ["story", "cards"], () => null).length;

    const cards = get(this.props, ["story", "cards"], []);

    let firstVideoElement;
    let firstVideoCard = {};

    for (let cardIterator = 0; cardIterator < cards.length; cardIterator++) {
      const foundVideo = cards[cardIterator]["story-elements"].find(
        ({ type, subtype }) => type === "youtube-video" || (type === "jsembed" && subtype === "dailymotion-video")
      );
      if (foundVideo) {
        firstVideoElement = foundVideo;
        firstVideoCard = cards[cardIterator];
        break;
      }
    }

    const renderHeaderVideo = () => {
      if (!firstVideoElement) {
        return null;
      }

      return (
        <div className={stylesVideo["header-video"]}>
          <StoryElement
            element={firstVideoElement}
            card={firstVideoCard}
            key={firstVideoElement.id}
            story={this.props.story}
          />
        </div>
      );
    };

    return (
      <div className={`main-page ${stylesVideo["video"]} js-story-main-container`}>
        {!isPremium(this.props.story) && (
          <DfpAd story={this.props.story} className="hidden-mobile ad-tower-left" adtype="Tower_Left" placement="all" />
        )}
        <div className="page-content">
          <div className={`container`}>
            <Breadcrumb story={this.props.story} config={this.props.config} className={stylesVideo.breadcrumb} />
          </div>
          <div className={`container ${styles["story-grid"]}`}>
            <div className={styles["main-content"]}>
              <article className={`${styles["story-body"]} ${stylesVideo["story-body"]} js-story`}>
                {renderHeaderVideo()}
                {renderHeaderCard()}
                {this.props.story.cards.map((card, index) => {
                  const newCard = produce(card, draft => {
                    draft["story-elements"] = draft["story-elements"].filter(
                      element => element.id !== firstVideoElement.id
                    );
                  });
                  return (
                    <React.Fragment key={newCard.id}>
                      {index === 1 && renderStoryNewsletter()}
                      {index === 3 &&
                        !isPremium(this.props.story) && (
                          <DfpAd story={this.props.story} adtype="Inarticle_fork" placement="story" />
                        )}
                      <StoryCard card={newCard} story={this.props.story} />
                      {index !== getStorycardLength - 1
                        ? !isPremium(this.props.story) && (
                            <DfpAd story={this.props.story} adtype="Rectangle" placement="story" />
                          )
                        : ""}
                    </React.Fragment>
                  );
                })}
                {renderFooter()}
              </article>
              {renderSocialMedia("show-desktop")}
              {renderfloatingBar()}
            </div>
            {renderSidebar()}
          </div>
        </div>
        {!isPremium(this.props.story) && (
          <DfpAd
            story={this.props.story}
            className="hidden-mobile ad-tower-right"
            adtype="Tower_Right"
            placement="all"
          />
        )}
      </div>
    );
  }
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
VideoStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { VideoStory };
